
export function disableScrolling(body: HTMLBodyElement, isInitiallyDisabled: boolean) {

    const handler = (disable: boolean) => {
        // bootstrap way to disable scrolling
        return disable ? body.classList.add('disable-scrolling') : body.classList.remove('disable-scrolling');
    }

    handler(isInitiallyDisabled);

    return {
        update: handler,
        destroy: () => body.classList.remove('disable-scrolling')
    }
}